/**
 * 通知管理组件
 */

import {
    Style
} from '@/libs/style.js';

let template = /*html*/ `<div class="app-notification">
<div class="app-notification-header">
    <!--<img src="./images/default/2.png" alt="">-->
    <h2>通知管理</h2>
    <dv-decoration-1 style="width:200px;height:100%;position:absolute;right:0;" />
</div>
<el-tabs v-model="activeName" @tab-click="handleClick" class="tab-section" :stretch="true">
    <el-tab-pane class="tab-item" label="故障" name="malfunction">
        <div class="notification-error">
            <div class="status-nav">
                <div class="num">序列号</div>
                <div class="content">内容</div>
                <div>时间</div>
            </div>
            <div class="noti-msg" v-for="(item,index) in 3">
                <div class="msg-item">{{index+1}}</div>
                <div class="msg-item"> 污水提升泵变频器{{index+1}}#1</div>
                <div class="msg-item">{{index+1}}h</div>
            </div>
        </div>
    </el-tab-pane>
    <el-tab-pane class="tab-item" label="通知" name="notification">通知</el-tab-pane>
    <el-tab-pane class="tab-item" label="报警" name="warn">报警</el-tab-pane>
  </el-tabs>
</div>`;


let style = /* css */ `.app-notification{
    position: absolute;
    top: 66%;
    left: 1%;
    width: 25%;
    background: rgba(0,0,0,0.2);
    height: 30%;
    overflow: hidden;
}
.app-notification .el-tabs__header{
    margin-bottom:0;
}
.app-notification .app-notification-header{
    padding-left:15px;
    background:linear-gradient(to right,#159AFF80,rgba(0,0,0,0) 100%);
    height: 50px;
    color: #fff;
    display:flex; 
    align-items:center;
    position:relative;
}
.app-notification .app-notification-header img{
    margin:0 15px;
}

.app-notification .tab-section{
    padding:0 20px;
    color:#fff;
    height:100%;
}
.app-notification .tab-item{
    color:#fff;
}
.app-notification .el-tabs__item{
    color:#fff;
}

.app-notification .notification-error{
    overflow-y: auto;
    height: 250px;
    
    
}
.app-notification .notification-error::-webkit-scrollbar{
    display:none;
}
.app-notification .status-nav{
    background:rgba(2,70,143,.2);
    display: flex;
    justify-content: space-between;
    color: #159AFF;
    padding: 10px 30px;
    font-size: 14px;
    
}
.app-notification .status-nav .num{

}
.app-notification .status-nav .content{
    text-align:left;
    width:50%;
}
.app-notification .noti-msg{
    display: flex;
    justify-content: space-between;
    padding: 10px 30px;
    color: #fff;
    font-size: 16px;
    cursor: pointer;
}
.app-notification .noti-msg:hover{
}
.app-notification .msg-item{
    overflow: hidden;
    text-align: center;
    font-size:14px;
}
.app-notification .msg-item:nth-child(1){
        width: 40px;
        text-align: center;
        color:#FF7734;
        border:1px solid #FF7734;
}
.app-notification .msg-item:nth-child(2){
    width: 50%;
    text-align: left;

}
`;

export default (Vue) => {
    Vue.customElement('xbt-app-notification', {
        template: template,
        data() {
            return {
                activeName: 'malfunction'
            }
        },
        mounted() {
            Style(style);
        },
        methods: {
            handleClick(tab, event) {
                console.log(tab, event);
            }
        }
    });
}